// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1C1xf","selects":"Documents_selects__XMyHu"};